module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portofolio-laminar.json
// module id = 851
// module chunks = 195196023747953